import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { WhatsappLogo, EnvelopeSimple, Phone } from '@phosphor-icons/react';
import FAQSection from '../components/FAQSection';

const FAQ = () => {
  return (
    <div className="min-h-screen bg-background-default">
      {/* Hero */}
      <section className="bg-background-subtle py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1 className="font-display text-4xl md:text-5xl text-secondary mb-4">
              Frequently Asked Questions
            </h1>
            <p className="font-body text-text-secondary max-w-xl mx-auto">
              Everything you need to know about our products, shipping, returns, and more.
            </p>
          </motion.div>
        </div>
      </section>

      {/* FAQ Content */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <FAQSection showTitle={false} />
        </div>
      </section>

      {/* Still Have Questions */}
      <section className="py-16 bg-background-subtle">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center"
          >
            <h2 className="font-display text-3xl text-secondary mb-4">Still Have Questions?</h2>
            <p className="font-body text-text-secondary mb-8 max-w-lg mx-auto">
              Can't find the answer you're looking for? Our friendly team is here to help.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {/* WhatsApp */}
              <a
                href="https://wa.me/919421147643?text=Hi! I have a question about your jewelry."
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white p-6 hover:shadow-md transition-shadow group"
              >
                <div className="w-14 h-14 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-green-500 transition-colors">
                  <WhatsappLogo size={28} className="text-green-600 group-hover:text-white transition-colors" weight="fill" />
                </div>
                <h3 className="font-display text-lg text-secondary mb-2">WhatsApp</h3>
                <p className="font-body text-sm text-text-muted">Chat with us instantly</p>
              </a>

              {/* Email */}
              <a
                href="mailto:hello@lusteradorn.com"
                className="bg-white p-6 hover:shadow-md transition-shadow group"
              >
                <div className="w-14 h-14 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-primary transition-colors">
                  <EnvelopeSimple size={28} className="text-primary group-hover:text-white transition-colors" />
                </div>
                <h3 className="font-display text-lg text-secondary mb-2">Email Us</h3>
                <p className="font-body text-sm text-text-muted">hello@lusteradorn.com</p>
              </a>

              {/* Phone */}
              <a
                href="tel:+919421147643"
                className="bg-white p-6 hover:shadow-md transition-shadow group"
              >
                <div className="w-14 h-14 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-blue-500 transition-colors">
                  <Phone size={28} className="text-blue-600 group-hover:text-white transition-colors" />
                </div>
                <h3 className="font-display text-lg text-secondary mb-2">Call Us</h3>
                <p className="font-body text-sm text-text-muted">+91 94211 47643</p>
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Quick Links */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h3 className="font-display text-xl text-secondary mb-6">Helpful Links</h3>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/shop" className="btn-secondary">
              Browse Products
            </Link>
            <Link to="/contact" className="btn-secondary">
              Contact Us
            </Link>
            <Link to="/about" className="btn-secondary">
              About Us
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
